import { FC } from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

const Footer: FC = () => (
    <Text type="secondary" style={{ textAlign: 'center', display: 'block' }}>
        Carry Solutions Inc. © Picker Express - 2022
    </Text>
);

export { Footer };
